import { render, staticRenderFns } from "./shift-report.vue?vue&type=template&id=1b4e7333&scoped=true&"
import script from "./shift-report.js?vue&type=script&lang=js&"
export * from "./shift-report.js?vue&type=script&lang=js&"
import style0 from "./shift-report.scss?vue&type=style&index=0&id=1b4e7333&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4e7333",
  null
  
)

export default component.exports